import { getSpaRedirectUrl } from "./helpers/GlobalHelper";
import { getIsWhiteLabeled } from "./helpers/PermissionHelper";

const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0; // Only needed if you need to support the redirect flow in Firefox incognito
const b2cPolicies = {
    names: {
        signUpSignIn: "B2C_1_SignUpIn",
        forgotPassword: "B2C_1_PasswordReset",
        editProfile: "B2C_1_ProfileEdit"
    },
    authorities: {
        signUpSignIn: {
            authority: `https://${process.env.REACT_APP_TENANT_NAME}.b2clogin.com/${process.env.REACT_APP_TENANT_ID}/B2C_1_SignUpIn`,
        },
        forgotPassword: {
            authority: `https://${process.env.REACT_APP_TENANT_NAME}.b2clogin.com/${process.env.REACT_APP_TENANT_ID}/B2C_1_PasswordReset`,
        },
        editProfile: {
            authority: `https://${process.env.REACT_APP_TENANT_NAME}.b2clogin.com/${process.env.REACT_APP_TENANT_ID}/B2C_1_ProfileEdit`
        }
    },
    authorityDomain: `${process.env.REACT_APP_TENANT_NAME}.b2clogin.com`
};

// Config object to be passed to Msal on creation
export const msalConfig = {
    auth: {
        clientId: `${process.env.REACT_APP_CLIENT_ID}`,
        authority: b2cPolicies.authorities.signUpSignIn.authority,
        knownAuthorities: [b2cPolicies.authorityDomain],
        redirectUri: getIsWhiteLabeled() ? getSpaRedirectUrl() : "/",
        postLogoutRedirectUri: "/"
    },
    cache: {
        storeAuthStateInCookie: isIE || isEdge || isFirefox,
        cacheLocation: "localStorage"
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    scopes: [
        `https://${process.env.REACT_APP_TENANT_NAME}.onmicrosoft.com/api/full`,
        "openid"
    ],
    state: ""
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft-ppe.com/v1.0/me"
};